import * as React from 'react';

import {
  Select as BaseSelect,
  SelectProps,
  Menu as BaseMenu,
  MenuProps,
  TokenListInput as BaseTokenListInput,
  TokenListInputProps,
  StringListInput as BaseStringListInput,
  StringListInputProps,
  CustomTokenListInput as BaseCustomTokenListInput,
  CustomTokenListInputProps,
} from './new-stuff';
import css from './borderless.css';


export function Select<V>(props: SelectProps<V>) {
  return <BaseSelect baseClassNames={css} {...props} />;
}

export function Menu<V, O>(props: MenuProps<V, O>) {
  // @ts-expect-error - TS2322 - Type '{ name?: string | undefined; value: V | null | undefined; baseClassNames: { [className: string]: string; } | Readonly<Readonly<{ options?: string | null | undefined; down?: string | null | undefined; ... 5 more ...; optionGroupHeading?: string | ... 1 more ... | undefined; }> & { ...; }>; ... 6 more ...; onChange: (...' is not assignable to type 'IntrinsicAttributes & (MenuProps<V, { value: V; label: string; }> & Omit<Omit<RequiredInputAndOptionsProps<unknown> & OptionalInputAndOptionsProps<...>, "className" | ... 8 more ... | "isFocused">, "onChange" | ... 1 more ... | keyof CommonMenuProps<...>>)'.
  return <BaseMenu baseClassNames={css} {...props} />;
}

export function TokenListInput<V>(props: TokenListInputProps<V>) {
  return <BaseTokenListInput baseClassNames={css} {...props} />;
}

export function StringListInput(props: StringListInputProps) {
  return <BaseStringListInput baseClassNames={css} {...props} />;
}

export function CustomTokenListInput(props: CustomTokenListInputProps) {
  return <BaseCustomTokenListInput baseClassNames={css} {...props} />;
}
